/**
 * A booking's code, read exactly as the server reads it: appointment.NormaliseCode
 * (internal/appointment/appointment.go). Shared by the kiosk's keypad
 * (kioskBooking.ts's typedCode, for a code typed, scanned or pasted from a link)
 * and reception's search (bookings.ts's stillToArrive, for a code typed into the
 * Bookings card) — one reading of a code, so the two screens never disagree about
 * which booking a code names.
 */
export function normaliseCode(typed: string): string {
  const entry = normaliseEntry(typed)
  return isPass(entry) ? entry.slice(PASS_DIGITS) : entry
}

/** appointment.PassDigits: a scanned pass (appointment/pass.go) is this many digits, then its code. */
export const PASS_DIGITS = 273

/** appointment.LooksLikePass: digits, longer than any code (4–32) and no longer than a pass. */
export function isPass(entry: string): boolean {
  return entry.length >= PASS_DIGITS + 4 && entry.length <= PASS_DIGITS + 32 && /^\d+$/.test(entry)
}

/** normaliseCode without reading a pass as its code: what the kiosk sends, so an edge can check the pass. */
export function normaliseEntry(typed: string): string {
  const cut = Math.max(typed.lastIndexOf('/'), typed.lastIndexOf('='), typed.lastIndexOf('#'))
  return (cut >= 0 ? typed.slice(cut + 1) : typed).toUpperCase().replace(/[^A-Z0-9]/g, '')
}
